import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_VA1 = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question1')
    }

    const title = "VA-Verbal ability";
    const url = "https://careers4me.in/videos/Verbal_ability_part_1.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_VA1